import { HostMessage, HostMessageType } from '@playcastdotio/Messaging';
import { remoteHostList, machineCredentialsState } from '../../../stores/shared';
import { redactPresignedUrl } from '../../realtime/handlers/host';

type RemoteHost = (typeof remoteHostList)['currentState']['hosts']['uniqueId'];

function logHostMessage(message: HostMessage): void {
  if ('uploadUrl' in message && typeof message.uploadUrl === 'string') {
    console.log('Host message:', {
      ...message,
      uploadUrl: redactPresignedUrl(message.uploadUrl),
    });
    return;
  }
  console.log('Host message:', message);
}

export const handleHostMessage = (message: HostMessage) => {
  logHostMessage(message);

  switch (message.type) {
    case HostMessageType.HOST_SETTINGS_UPDATE: {
      const machineId = message.machineId;
      const active = remoteHostList.currentState.hosts[machineId];
      const inactive = remoteHostList.currentState.inactive[machineId];

      const isOffline = !active && inactive;

      const settings = message.settings;
      const remoteHostObj: RemoteHost = {
        remoteId: active?.remoteId ?? inactive?.remoteId ?? '',
        uniqueId: machineId,
        displayName: settings.displayName ?? active?.displayName ?? inactive?.displayName ?? '',
        machineId: machineId,
        environment: 'test',
        version: settings.version ?? active?.version ?? inactive?.version ?? '1.0.0',
        joinedCount: active?.joinedCount ?? 0,
        pendingCount: -1,
      };

      delete remoteHostList.currentState.inactive[machineId];
      delete remoteHostList.currentState.hosts[machineId];

      if (isOffline) {
        remoteHostList.currentState.inactive[machineId] = remoteHostObj;
      } else {
        remoteHostList.currentState.hosts[machineId] = remoteHostObj;
      }

      remoteHostList.updateState({
        ...remoteHostList.currentState,
        inactive: { ...remoteHostList.currentState.inactive },
        hosts: { ...remoteHostList.currentState.hosts },
      });
      break;
    }
  }
};

